import * as Config from '../../config';
import Locale from '../../utils/Locale';
import * as UUID from '../../utils/Uuid';
import { AlertInfo, AlertType, AlertRecord, AlertCategories } from "../Types";
import { AlertLogic } from './AlertLogic';
import { ContentCategories } from "../../types";
import { getSaltChlorineErrorLocalised, SaltChlorinatorErrors } from '../../status';



export class SaltChlorinator extends AlertLogic {
    static type = AlertType.SaltChlorinator;
    static category = AlertCategories.WATER_QUIALITY;
    static contentCategories = [ ContentCategories.WATER_QUALITY ];
    static title = Locale.gettext('Salt Chlorinator Issue');

    getInfo(timeZone?: string): AlertInfo {
        const alert = this.alert;
        const config = this.allConfigs;
        
        // Same for all alert types
        let { body, device, alertData, firstReported } = this.getCommons(timeZone);
        
        // Varying across alert types
        const errors: string[] = [];
        if (alertData?.ErrorStates) {
            Object
            .entries(alertData.ErrorStates)
            .forEach(([ key, val ]) => {
                errors.push(
                    getSaltChlorineErrorLocalised(key as SaltChlorinatorErrors)
                    + "\n" + this.locale.gettext("First reported at: %s",
                        this.locale.formatDateTime(new Date(val as string))
                    )
                );
            });
        }

        const alertInfo = AlertInfo.fromCardConfig({
            cardTitle: this.locale.gettext('Salt Chlorinator Issue'),
            cardDescription: this.locale.gettext('%1$s is reporting an issue.', device.Name),
            cardIllustration: 'pipes_emergency',
            detailIcon: 'salt-cell',
            detailDescription: this.locale.gettext('%1$s%2$s is reporting an issue.', 
                device.Name, 
                device.HardwareDevice?.UniqueBusIdentifier ?
                    ' (Serial port: ' + device.HardwareDevice?.Ports?.[0]?.Number + ', Bus ID : ' + device.HardwareDevice?.UniqueBusIdentifier + ')' :
                    ''
            ),
            detailDescriptionArr: errors,
            actionButtonTitle: '',
            resolveSummary: this.locale.gettext('%1$s error cleared', device.Name)
        });
        alertInfo.contentCategories = SaltChlorinator.contentCategories;
        return alertInfo;
    }

    static mock(type:AlertType, config:Config.AllConfig):AlertRecord|AlertRecord[] {
        const deviceUuid = config.Config.Devices.find(dev => dev.DeviceType === "SaltCell")?.UUID ?? "DEVICE-UUID";
        
        const ErrorStates = {};
        Object.values(SaltChlorinatorErrors).forEach(item => {
            ErrorStates[ item ] = new Date();
        });

        return new AlertRecord({
            id: Math.floor(Math.random() * 100000),
            uuid: UUID.modifySection(4, UUID.modifySection(3, deviceUuid, "MOCK"), "ALRT" + type),
            siteId: Math.floor(Math.random() * 100000),
            entityUuid: deviceUuid,
            bodyUuid: config.Config.BodiesOfWater[0]?.UUID,
            type,
            data: {
                ErrorStates
            }
        });
    }
}